import debounce from 'lodash/debounce'

import {
  GaIconAdditionalHeartSmall,
  GaIconAdditionalHeartSmallFilled,
} from '@ga/icons'

import { useUser } from '~/modules/main'

import { useAnimation } from './scripts/composables/animation'

const FAVORITE_ICON = {
  OFF: GaIconAdditionalHeartSmall,
  ON: GaIconAdditionalHeartSmallFilled,
}

// @vue/component
export default {
  name: 'ga-favorites-button',

  props: {
    itemId: {
      type: [String, Number],
      default: null,
    },
    favourite: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
  },

  setup(props, { slots }) {
    const { animating, runAnimation } = useAnimation()

    const { $gaApp } = useNuxtApp()

    const { userIsAuth } = useUser()

    const items = computed(() => $gaApp.stores.product.main.favorites ?? [])

    const item = computed(() => ({
      id: props.itemId,
      name: props.name,
    }))

    const itemIsAdded = computed(() => {
      return items.value.includes(props.itemId)
    })

    const icon = computed(() => {
      return itemIsAdded.value ? FAVORITE_ICON.ON : FAVORITE_ICON.OFF
    })

    const onClick = debounce(() => {
      if (!userIsAuth.value) {
        // TODO: запрос авторизации?
        return
      }

      if (itemIsAdded.value) {
        $gaApp.services.product.favorites.deleteItem(item.value)
      } else {
        $gaApp.services.product.favorites.addItem(item.value)
      }

      runAnimation()
    }, 200)

    onMounted(() => {
      if (props.favourite) {
        const setItem = () =>
          $gaApp.services.product.favorites.setItem(props.itemId)

        $gaApp.services.app.scheduler.postTask(setItem)
      }
    })

    return () =>
      slots.default({
        icon: icon.value,
        isAdded: itemIsAdded.value,

        isAnimating: animating.value,

        addToFavorites: onClick,
      })
  },
}
